import apiClient from './client'

export interface DicionarioThorRecord {
  cndicionariothor: number
  nmtabela: string
  nmcoluna: string
  tpcoluna?: string | null
  qtsize?: number | null
  qtdecimal?: number | null
  nmlabel?: string | null
  nmheader?: string | null
  dscoluna?: string | null
  dsnome?: string | null
  status: string
  id_logsautenticacao?: number | null
  created_at: string
  updated_at: string
}

export interface DicionarioThorListParams {
  tabela?: string
  coluna?: string
  status?: string
  texto?: string
  limit?: number
  offset?: number
}

export interface DicionarioThorUpdatePayload {
  tpcoluna?: string | null
  qtsize?: number | null
  qtdecimal?: number | null
  nmlabel?: string | null
  nmheader?: string | null
  dscoluna?: string | null
  dsnome?: string | null
  status?: string | null
  id_logsautenticacao?: number | null
}

export const dicionarioThorApi = {
  list: async (
    params: DicionarioThorListParams = {}
  ): Promise<DicionarioThorRecord[]> => {
    const response = await apiClient.get<DicionarioThorRecord[]>(
      '/config/dicionariothor/lista',
      { params }
    )
    return response.data
  },

  update: async (
    id: number,
    payload: DicionarioThorUpdatePayload
  ): Promise<DicionarioThorRecord> => {
    const response = await apiClient.put<DicionarioThorRecord>(
      `/config/dicionariothor/${id}`,
      payload
    )
    return response.data
  },
}


